import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { ErrorState } from '@/components/ui';

/**
 * Router-level boundary. Catches a failed lazy chunk or a throw from any loader
 * or element so a single broken screen never blanks the whole app.
 */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  const message = isRouteErrorResponse(error)
    ? `${error.status} — ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Erro inesperado ao abrir esta tela.';

  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-2xl items-center px-gutter">
      <ErrorState
        title="Algo saiu do traçado"
        titleAs="h1"
        message={message}
        retryLabel="Recarregar"
        onRetry={() => navigate(0)}
      />
    </div>
  );
}

export default RouteError;
